export default {
    getVendorListing: (data) => window.axios.post('restaurants', data),
    getVendorDetails: (data) => window.axios.get(`restaurants/${data.restaurant_id}?latitude=${data.latitude}&longitude=${data.longitude}`, data),
    getRestaurantMenuWiseCategory: (data, restaurant_id) => window.axios.get(`restaurants/${restaurant_id}/category-wise-menu/0`, data),
    MenuWiseItems: (data) => window.axios.get(`restaurants/${data.restaurant_id}/category/0/menu/${data.menu_id}?skip=${data.skip}&total_record=${data.total_record}`),
    getRestaurantMenuCategory: (data, restaurant_id) => window.axios.get(`restaurants/${restaurant_id}/categories`, data),
    getRestaurantRating: (data) => window.axios.get(`rating/restaurant/${data.restaurant_id}`, data),
    searchRestaurant: (data) => window.axios.post('search/restaurants', data),
    searchRestaurantItems: (data) => window.axios.get(`search/items?search=${data.search}&latitude=${data.latitude}&longitude=${data.longitude}`),
    searchRestaurantItemsSearch: (data) => window.axios.get(`search/items?search=${data.search}&latitude=${data.latitude}&longitude=${data.longitude}&restaurant_id=${data.restaurant_id}`),

    getRestaurantTiming: (data) => window.axios.get(`restaurants/${data.restaurant_id}/timeslots?is_delivery=${data.is_delivery}`, data),
    viewRestaurantTiming: (data) => window.axios.get(`restaurants/${data.restaurant_id}/timings`, data),

    checkVendorRadius: (data) => window.axios.post('cart/check-radius', data),

    currentLocationRestaurant: (data) => window.axios.get(`restaurants/get-nearest-restaurant?latitude=${data.latitude}&longitude=${data.longitude}&delivery_type=${data.delivery_type}`, data),


    getVendorOnOffStatus: (data) => window.axios.post('get_restaurant_on_off', data),

    checkVendorMenuWithPrice: (data) => window.axios.post('check_restaurant_menu_with_price', data),



    getRestaurantCategorylisting: (data) => window.axios.get('categories', data),

    getItemsSoldStatus: (data) => window.axios.post('get_items_status', data),


    searchRestaurantCategoryItem: (data) => window.axios.post('search_restaurant_category_item', data),

    getBrandList: (data) => window.axios.post('brands', data),
    // getBrandRestaurantList: (data) => window.axios.post('brand-restaurant', data),
    getBrandRestaurantList: (data, brand_id) => window.axios.post(`brands/${brand_id}/restaurants`, data),

    getDunzoQuotation: (data) => window.axios.post('get-dunzo-quotation', data),
    // getTagWiseRestaurantItem: (data) => window.axios.post('tag_wise_restaurant_menu_item', data),
    getTagWiseRestaurantItem: (restaurantId, params) => window.axios.get(`restaurants/${restaurantId}/get-tag-wise-items`, { params }),

}
